// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__a3mk0","animated":"Box_animated__hI1Sl"};